import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";

function CartChatpterComp({ value, status, settab, userAllContent }) {
  const navigate = useNavigate();
  const contentId = useSelector((state) => state.extra.Id);
  const sandValue = async () => {
    if (userAllContent) {
      try {
        const response = await api.post("extrapost_statistics", userAllContent); // Baştaki slash'ı kaldırarak dene
        if (response.status === 200) {
          navigate("/cartpage");
        }
        settab(0);
      } catch (err) {
        console.error(err, "hata verdi");
      }
    }
  };

  return (
    <div
      className="flex flex-col bg-white border-4 border-purple-400 
    shadow-[0_8px_0_0_#a855f7] justify-center items-center p-8 gap-6 rounded-3xl
     max-w-sm mx-auto transform transition-all"
    >
      <div className="flex flex-col items-center gap-2">
        <div className="text-6xl mb-2 animate-bounce">🏆</div>
        <div className="text-6xl mb-2 animate-bounce">🥳</div>
        <h1
          className="text-purple-600 text-3xl font-black text-center 
        uppercase tracking-tight"
        >
          Harika İş!
        </h1>
        <div className="space-y-2">
          <p className="text-gray-500 font-medium text-center leading-tight">
            Bu bölümü başarıyla tamamladın. <br />
            <span className="text-gray-400 text-sm">
              Bir sonraki bölüm için devam etmak için exsersizniz seçiniz!
            </span>
          </p>
        </div>
      </div>

      <div className="flex flex-col w-full gap-3">
        <button
          onClick={sandValue}
          className="bg-emerald-500 hover:bg-emerald-400 text-white 
          font-bold py-4 px-6 rounded-2xl shadow-[0_4px_0_0_#059669] active:shadow-none
           active:translate-y-1 transition-all duration-75 text-lg"
        >
          sonuncun kaydet
        </button>
      </div>
    </div>
  );
}

export default CartChatpterComp;
